import * as React from "react";
import { Redirect, useLocation } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import {
    BAM_SUPPORT_ROUTE,
    deriveRedirectTarget,
    detectApplicationFromPath,
    SUPPORT_ROUTE,
} from "components/router/Routes";
import { Application } from "store/application";

const SupportView = (): JSX.Element => {
    const { pathname } = useLocation();
    const isRouteEnabled = useIsRouteEnabled();

    const route = detectApplicationFromPath(pathname) === Application.BAM ? BAM_SUPPORT_ROUTE : SUPPORT_ROUTE;
    const target = deriveRedirectTarget(route, isRouteEnabled);

    return <Redirect to={target.path} />;
};

export default SupportView;
